/**
 *
 * braze native interface
 *
 * See complete typing at https://github.com/braze-inc/braze-cordova-sdk/blob/master/www/BrazePlugin.js#L1
 *
 * */

type NotificationSubscriptionTypes = 'opted_in' | 'subscribed' | 'unsubscribed';

interface BrazePlugin {
  changeUser: (userId: string, signature?: string) => void;
  logCustomEvent: (
    eventName: string,
    eventProperties?: Record<string, unknown>
  ) => boolean;
  setFirstName: (firstName: string | null) => boolean;
  setEmail: (email: string | null) => boolean;
  setPushNotificationSubscriptionType: (
    notificationSubscriptionType: NotificationSubscriptionTypes
  ) => boolean;
  NotificationSubscriptionTypes: {
    OPTED_IN: 'opted_in';
    SUBSCRIBED: 'subscribed';
    UNSUBSCRIBED: 'unsubscribed';
  };
  requestPushPermission(
    successCallback?: (
      endpoint: string,
      publicKey: string,
      userAuth: string
    ) => void,
    deniedCallback?: (temporaryDenial: boolean) => void
  ): void;
}

/**
 *
 * On native apps `BrazePlugin` is available on the window object
 * @returns BrazePlugin | undefined
 *
 */
export function useBrazeNativeSDK() {
  if (RUNTIME_ENV !== 'native') return undefined;
  if (typeof (window as any).BrazePlugin !== 'undefined') {
    return (window as any).BrazePlugin as BrazePlugin;
  }
}
